module.exports = __webpack_public_path__ + "img/bg.70991724.png";